import {
  Image,
  SignIn,
  RecentOrderHistory,
  PrivateLabelCreditCard,
  StoreDetails,
  Section,
  Hero,
  ComponentVariations,
  HeroFlattenImage,
  SpecialBuyOfTheDay,
  OnlineWorkshops,
  Tile,
  Spotlight,
  ShopByCategory,
  VisualNavigation,
  PopularCategories,
  PersonalizedHomeServices,
  UserList,
  Recommendations,
  WelcomeMessage,
  SponsoredBanner,
  LoyaltyBenefits,
  SpecialBuyOfTheWeek,
} from '.';

import { CUSTOMER_TYPES } from '../utils';
import {
  SCROLL_BUFFER_DESKTOP,
  SCROLL_BUFFER_MOBILE,
  HOMEPAGE_DELAY_STANDARD,
  HOMEPAGE_PLACEHOLDER_DESKTOP,
  HOMEPAGE_PLACEHOLDER_MOBILE,
  SECTION_PLACEHOLDER_DESKTOP,
  SECTION_PLACEHOLDER_MOBILE,
} from '../utils/constants';

const createComponents = ({
  customerType,
  guestUserId,
  mcvisID,
  store,
  userAuthStatus,
  channel,
  windowWidthMeasure = 'minWidthLarge',
}) => {
  const isB2B = customerType === CUSTOMER_TYPES.B2B;

  // determining the constants hydrators
  let PLACEHOLDER = channel === 'mobile'
    ? HOMEPAGE_PLACEHOLDER_MOBILE
    : HOMEPAGE_PLACEHOLDER_DESKTOP;
  let PLACEHOLDER_SECTION = channel === 'mobile'
    ? SECTION_PLACEHOLDER_MOBILE
    : SECTION_PLACEHOLDER_DESKTOP;
  let SCROLL_BUFFER = channel === 'mobile' ? SCROLL_BUFFER_MOBILE : SCROLL_BUFFER_DESKTOP;

  const hydrationOptions = {
    SCROLL_BUFFER,
    HOMEPAGE_DELAY_STANDARD,
    PLACEHOLDER,
  };

  return {
    Image,

    SignIn: SignIn(hydrationOptions),

    RecentOrderHistory: RecentOrderHistory(hydrationOptions),

    PrivateLabelCreditCard: PrivateLabelCreditCard(hydrationOptions),

    StoreDetails: StoreDetails({
      ...hydrationOptions,
      channel,
      store,
      isB2B,
    }),

    Section: Section({ SCROLL_BUFFER, PLACEHOLDER_SECTION, mcvisID, store }),

    Hero,

    ComponentVariations: ComponentVariations({
      ...hydrationOptions,
      PLACEHOLDER_SECTION,
      channel,
    }),

    HeroFlattenImage: HeroFlattenImage({ channel }),

    SpecialBuyOfTheDay: SpecialBuyOfTheDay(hydrationOptions),

    SpecialBuyOfTheWeek: SpecialBuyOfTheWeek(hydrationOptions),

    OnlineWorkshops: OnlineWorkshops({
      ...hydrationOptions,
      isB2B,
    }),

    Tile: Tile(hydrationOptions),

    Spotlight: Spotlight(hydrationOptions),

    ShopByCategory: ShopByCategory(hydrationOptions),

    VisualNavigation,

    PopularCategories: PopularCategories(hydrationOptions),

    PersonalizedHomeServices: PersonalizedHomeServices(hydrationOptions),

    UserList: UserList(hydrationOptions),

    Recommendations: Recommendations({
      ...hydrationOptions,
      store,
      customerType,
      windowWidthMeasure,
      guestUserId,
      mcvisID,
      userAuthStatus,
    }),

    welcomeMessage: WelcomeMessage({
      userAuthStatus,
    }),

    SponsoredBanner: SponsoredBanner({
      SCROLL_BUFFER,
      PLACEHOLDER,
    }),

    LoyaltyBenefits,
  };
};

export { createComponents };
